import { Link } from "react-router-dom";
import { Page, Logo } from "@/components/common";

export default function NotFound() {
  return (
    <Page className="text-center">
      <Logo className="h-20 w-20 mx-auto" />
      <h1 className="mt-6 font-display text-5xl font-black">Nothing here</h1>
      <Link to="/" data-testid="notfound-home-link" className="mt-6 inline-block px-6 py-3 rounded-full bg-stone-900 text-white font-semibold text-sm">Back home</Link>
    </Page>
  );
}
